var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkordersactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#414141;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Work_orders_active",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_10_00000104684867383188756600000009161886178429772962_",
    className: "st0",
    d: "M36.4,44.6H9.6 c-2.1,0-3.8-1.7-3.8-3.8V10.1c0-2.1,1.7-3.8,3.8-3.8h3.8v7.1h19.2V6.3h3.8c2.1,0,3.8,1.7,3.8,3.8v30.6 C40.3,42.9,38.6,44.6,36.4,44.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.4,46.5H9.6c-3.2,0-5.8-2.6-5.8-5.8V10.1c0-3.2,2.6-5.8,5.8-5.8h3.8c1.1,0,1.9,0.9,1.9,1.9v5.1h15.4V6.3 c0-1.1,0.9-1.9,1.9-1.9h3.8c3.2,0,5.8,2.6,5.8,5.8v30.6C42.2,43.9,39.6,46.5,36.4,46.5z M9.6,8.2c-1.1,0-1.9,0.9-1.9,1.9v30.6 c0,1.1,0.9,1.9,1.9,1.9h26.9c1.1,0,1.9-0.9,1.9-1.9V10.1c0-1.1-0.9-1.9-1.9-1.9h-1.9v5.1c0,1.1-0.9,1.9-1.9,1.9H13.4 c-1.1,0-1.9-0.9-1.9-1.9V8.2H9.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.9,9.1h-3.8c-2.1,0-3.8-1.7-3.8-3.8V3.3c0-2.1,1.7-3.8,3.8-3.8h3.8c2.1,0,3.8,1.7,3.8,3.8v1.9 C28.8,7.4,27,9.1,24.9,9.1z M21.1,3.3L21.1,3.3v1.9h3.8V3.3H21.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.6,15.4H13.4c-1.1,0-1.9-0.9-1.9-1.9V1.4c0-1.1,0.9-1.9,1.9-1.9h19.2c1.1,0,1.9,0.9,1.9,1.9v12.1 C34.5,14.6,33.7,15.4,32.6,15.4z M15.3,11.6h15.4V3.3H15.3V11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.8,26.4H13.4c-1.1,0-1.9-0.9-1.9-1.9c0-1.1,0.9-1.9,1.9-1.9h13.4c1.1,0,1.9,0.9,1.9,1.9 C28.8,25.5,27.9,26.4,26.8,26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23,34h-9.6c-1.1,0-1.9-0.9-1.9-1.9s0.9-1.9,1.9-1.9H23c1.1,0,1.9,0.9,1.9,1.9S24.1,34,23,34z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkordersactive);
export default __webpack_public_path__ + "static/media/Work orders active.7ce8dd3ac4c9f4704de35a3222791825.svg";
export { ForwardRef as ReactComponent };